/* J HERBS — cart drawer (assets/jh-cart-drawer.js)  v2 · 30 Oct 2026
   Fixes:
   - Wrong total after changing a quantity. Shopify's /cart/change.js answer can
     carry a total_price that already includes an estimated shipping amount
     (seen live: D3 x1 = £12.97 + fee £3.59, change.js said £22.54 instead of
     £16.56). The drawer then added shipping again. Totals are now worked out
     from the line items themselves, and the cart is re-read after every change.
   - Shows a Subtotal row (products only), like the cart page and checkout.
   - Same money format as the rest of the site (£12.99, not "GBP 12.99").
   - + / − can't be double-clicked into a wrong state while the cart updates.
   Everything else works as before (same IDs, same settings from jhCartConfig). */
(function () {
  var cfg = window.jhCartConfig || {},
    cartUrl = cfg.cartUrl, cartAddUrl = cfg.cartAddUrl, cartChangeUrl = cfg.cartChangeUrl,
    freeShipThreshold = 4000, ukShippingRateCents = cfg.ukShippingRateCents || 399,
    i18n = cfg.i18n || {}, currency = cfg.currency || '',
    FEE_HANDLE = 'duties-and-services', lastAdded = null, renderSeq = 0, busy = false,
    AR = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0,
    overlay = document.getElementById('jhCdOverlay'), panel = document.getElementById('jhCdPanel'),
    closeBtn = document.getElementById('jhCdClose'), body = document.getElementById('jhCdBody'),
    foot = document.getElementById('jhCdFoot'), addedSlot = document.getElementById('jhCdAddedSlot'),
    shipSlot = document.getElementById('jhCdShipSlot'), subtotalEl = document.getElementById('jhCdSubtotal'),
    shippingRowEl = document.getElementById('jhCdShippingRow'), dutiesRowEl = document.getElementById('jhCdDutiesRow');
  if (!panel) return;

  function getRate() { return window.Shopify && Shopify.currency && Shopify.currency.rate ? parseFloat(Shopify.currency.rate) : 1; }
  function moneyFmt(cents, code) {
    code = code || currency;
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: code }).format(cents / 100); }
    catch (e) { return code + ' ' + (cents / 100).toFixed(2); }
  }
  window.jhMoney = window.jhMoney || moneyFmt;

  /* Subtotal row (products only) — added once, above Shipping */
  var subRowEl = document.getElementById('jhCdSubRow');
  if (!subRowEl && shippingRowEl) {
    subRowEl = document.createElement('div');
    subRowEl.className = 'jh-cd-row jh-cd-subrow';
    subRowEl.id = 'jhCdSubRow';
    shippingRowEl.parentNode.insertBefore(subRowEl, shippingRowEl);
  }
  var subLabel = i18n.subtotal || (AR ? 'الإجمالي الفرعي' : 'Subtotal');

  function openDrawer() { overlay.classList.add('open'); panel.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { overlay.classList.remove('open'); panel.classList.remove('open'); document.body.style.overflow = ''; }
  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function updateHeaderCount(count) {
    var badge = document.querySelector('.jh-hdr .cart-count'),
      cartIcon = document.querySelector('.jh-hdr a[href*="/cart"].ic');
    if (count > 0) {
      if (badge) badge.textContent = count;
      else if (cartIcon) { var s = document.createElement('span'); s.className = 'cart-count'; s.textContent = count; cartIcon.appendChild(s); }
    } else if (badge) badge.remove();
  }

  function renderShipBar(total, code, threshold, forceFree) {
    var unlocked = typeof forceFree === 'boolean' ? forceFree : total >= threshold;
    if (unlocked) {
      shipSlot.innerHTML = '<div class="jh-cd-ship">🎉 ' + i18n.freeUnlocked + '<div class="bar"><div class="fill" style="width:100%"></div></div></div>';
    } else {
      var remaining = Math.max(1, threshold - total), pct = Math.min(100, total / threshold * 100);
      shipSlot.innerHTML = '<div class="jh-cd-ship">' + i18n.freeAwayPre + ' <b>' + moneyFmt(remaining, code) + '</b> ' + i18n.freeAwayPost +
        '<div class="bar"><div class="fill" style="width:' + pct + '%"></div></div></div>';
    }
  }
  function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  function renderCart(cart, justAdded) {
    var mySeq = ++renderSeq, feeCents = 0, feeQty = 0, productsCents = 0, productsQty = 0, shown = [];
    cart.items.forEach(function (it) {
      if (it.handle === FEE_HANDLE) { feeCents += it.final_line_price; feeQty += it.quantity; }
      else { shown.push(it); productsCents += it.final_line_price; productsQty += it.quantity; }
    });
    var itemsTotal = productsCents + feeCents;            /* never trust cart.total_price here */
    updateHeaderCount(productsQty);

    var code = cart.currency || currency, rate = getRate(), isSar = code === 'SAR',
      threshold = isSar ? 20000 : Math.round(freeShipThreshold * rate),
      estShipping = isSar ? 2000 : Math.round(ukShippingRateCents * rate);
    renderShipBar(itemsTotal, code, threshold);

    addedSlot.innerHTML = justAdded
      ? '<div class="jh-cd-added"><span class="tick">✓</span><div class="txt">' + i18n.addedTo + '<span>' + esc(justAdded.product_title) + '</span></div></div>'
      : '';

    if (productsQty === 0) {
      body.innerHTML = '<div class="jh-cd-empty"><div class="ic">🛍</div><p>' + i18n.empty + '</p></div>';
      foot.style.display = 'none';
      return;
    }
    foot.style.display = 'block';
    if (subRowEl) subRowEl.innerHTML = '<span>' + subLabel + '</span><span>' + moneyFmt(productsCents, code) + '</span>';

    function paintShipping(shipCents) {
      subtotalEl.textContent = moneyFmt(itemsTotal + shipCents, code);
      shippingRowEl.innerHTML = shipCents === 0
        ? '<span>' + i18n.shipping + '</span><span class="jh-cd-free-tag">' + i18n.free + '</span>'
        : '<span>' + i18n.shipping + '</span><span>' + moneyFmt(shipCents, code) + '</span>';
    }
    paintShipping(itemsTotal >= threshold ? 0 : estShipping);
    if (window.jhRealShipping) {
      window.jhRealShipping().then(function (real) {
        if (mySeq !== renderSeq || !real || (real.currency && real.currency !== code)) return;
        paintShipping(real.cents);
        renderShipBar(itemsTotal, code, threshold, real.cents === 0);
      }).catch(function () {});
    }

    if (feeCents > 0) {
      dutiesRowEl.style.display = '';
      dutiesRowEl.innerHTML = '<span>' + i18n.dutiesVat + '</span><span>' + moneyFmt(feeCents, code) + '</span>';
    } else { dutiesRowEl.style.display = 'none'; dutiesRowEl.innerHTML = ''; }

    var html = '';
    shown.forEach(function (item) {
      var img = item.image ? item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=160' : '';
      html += '<div class="jh-cd-line" data-key="' + esc(item.key) + '">' +
        '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" loading="lazy">' +
        '<div class="jh-cd-line-info"><div class="t">' + esc(item.product_title) + '</div>' +
        (item.variant_title ? '<div class="v">' + esc(item.variant_title) + '</div>' : '') +
        '<div class="jh-cd-line-bottom"><div class="jh-cd-qty">' +
        '<button type="button" class="jh-cd-minus" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="−">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" class="jh-cd-plus" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="+">+</button></div>' +
        '<span class="jh-cd-line-price">' + moneyFmt(item.final_line_price, code) + '</span></div>' +
        '<button type="button" class="jh-cd-remove" data-key="' + esc(item.key) + '">' + i18n.remove + '</button></div></div>';
    });
    body.innerHTML = html;
  }

  function fetchCart() { return fetch(cartUrl + '.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); }

  function changeLine(key, qty) {
    if (busy) return;
    busy = true; lastAdded = null;
    body.classList.add('jh-cd-loading');
    var url = cartChangeUrl.indexOf('.js') === -1 ? cartChangeUrl + '.js' : cartChangeUrl;
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(fetchCart)                                    /* re-read: change.js totals are not reliable */
      .then(function (cart) { renderCart(cart, null); })
      .catch(function () { window.location.href = cartUrl; })
      .finally(function () { busy = false; body.classList.remove('jh-cd-loading'); });
  }

  body.addEventListener('click', function (e) {
    var plus = e.target.closest('.jh-cd-plus'), minus = e.target.closest('.jh-cd-minus'), remove = e.target.closest('.jh-cd-remove');
    if (plus) changeLine(plus.dataset.key, parseInt(plus.dataset.qty, 10));
    else if (minus) changeLine(minus.dataset.key, Math.max(0, parseInt(minus.dataset.qty, 10)));
    else if (remove) changeLine(remove.dataset.key, 0);
  });

  function isAddToCartForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    return (form.getAttribute('action') || '').indexOf('/cart/add') !== -1;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAddToCartForm(form)) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'), original = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = i18n.adding; }
    fetch(cartAddUrl + '.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (added) {
        lastAdded = added;
        var sync = window.jhDutiesFeeSync ? window.jhDutiesFeeSync() : Promise.resolve();
        return sync.catch(function () {}).then(fetchCart).then(function (cart) { renderCart(cart, added); openDrawer(); });
      })
      .catch(function () { window.location.href = cartUrl; })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/cart"]');
    if (link && link.closest('.jh-hdr') && !/checkout/.test(link.getAttribute('href') || '')) {
      e.preventDefault(); lastAdded = null;
      fetchCart().then(function (cart) { renderCart(cart, null); openDrawer(); });
    }
  });
  document.addEventListener('jh:cart:changed', function () { fetchCart().then(function (cart) { renderCart(cart, lastAdded); }); });
})();